import styled from 'styled-components';

const fillWeekBlue = '#0066b3';

export const FillWeekWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-right: 8px;
  max-width: 100%;
`;

export const FillWeekInput = styled.input`
  box-sizing: border-box;
  width: 36px;
  max-width: 100%;
  min-width: 0;
  height: 28px;
  text-align: center;
  border: 1px solid #dbdbdb;
  border-radius: 2px;
  font-size: 12px;
  background-color: #fff;
  padding: 0;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &:focus {
    border-color: #fe5d71;
    outline: 0;
    box-shadow: 0 0 0 0.15rem rgba(219, 1, 28, 0.2);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const FillWeekBtn = styled.button`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  white-space: nowrap;
  color: ${fillWeekBlue};
  background-color: #fff;
  border: 1px solid ${fillWeekBlue};
  border-radius: 2px;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  &:hover:not(:disabled) {
    background-color: #e8f2fa;
    border-color: #004f8a;
    color: #004f8a;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;
